import React, { useState, useEffect } from 'react';
import { Box, Paper, Typography, Tabs, Tab } from '@mui/material';
import SurveySettings from './smallcomponents/SurveySettings';
import { useSurveyStore, QUESTION_TYPES } from '../surveyutilities/surveyStore';
import TextBlockProperties from './blockproperties/TextBlockProperties';
import MultipleChoiceBlockProperties from "./blockproperties/MultipleChoiceBlockProperties.jsx";
import SingleChoiceBlockProperties from "./blockproperties/SingleChoiceBlockProperties.jsx";
import RatingBlockProperties from "./blockproperties/RatingBlockProperties.jsx";
import TextAreaBlockProperties from "./blockproperties/TextAreaBlockProperties.jsx";
import FileUploadBlockProperties from "./blockproperties/FileUploadBlockProperties.jsx";
import DropdownBlockProperties from "./blockproperties/DropdownBlockProperties.jsx";
// TabPanel helper
const TabPanel = ({ children, value, index }) => (
    <div
        role="tabpanel"
        hidden={value !== index}
        id={`simple-tabpanel-${index}`}
        aria-labelledby={`simple-tab-${index}`}
    >
        {value === index && <Box sx={{ p: 3 }}>{children}</Box>}
    </div>
);

function EcxSurveyProperties() {
    const [tabValue, setTabValue] = useState(0);

    // Subscribe to selectedQuestionId and questions array directly
    const selectedQuestionId = useSurveyStore((state) => state.selectedQuestionId);
    const selectedQuestion = useSurveyStore((state) =>
        state.questions.find((q) => q.id === state.selectedQuestionId) || null
    );

    // Auto-switch tab depending on whether a question is selected
    useEffect(() => {
        if (!selectedQuestion) {
            setTabValue(0); // Survey settings
        } else {
            setTabValue(1); // Selected question
        }
    }, [selectedQuestion]);

    const handleTabChange = (event, newValue) => {
        setTabValue(newValue);
    };

    const renderProperties = () => {
        if (!selectedQuestion) {
            return (
                <Box sx={{ p: 2, textAlign: 'center', color: 'text.secondary' }}>
                    <Typography variant="body2">
                        No question selected. Select a question to edit its properties.
                    </Typography>
                </Box>
            );
        }

        switch (selectedQuestion.type) {
            case QUESTION_TYPES.TEXT:
                return <TextBlockProperties questionId={selectedQuestion.id} />;
            case QUESTION_TYPES.TEXTAREA:
                return <TextAreaBlockProperties questionId={selectedQuestion.id} />;
                case QUESTION_TYPES.SINGLE_CHOICE:
                    return <SingleChoiceBlockProperties questionId={selectedQuestion.id} />;
                    case QUESTION_TYPES.MULTIPLE_CHOICE:
                        return <MultipleChoiceBlockProperties questionId={selectedQuestion.id} />;
                        case QUESTION_TYPES.DROPDOWN:
                            return <DropdownBlockProperties questionId={selectedQuestion.id} />;
                            case QUESTION_TYPES.RATING:
                                return <RatingBlockProperties questionId={selectedQuestion.id} />;
                                case QUESTION_TYPES.FILE_UPLOAD:
                                    return <FileUploadBlockProperties questionId={selectedQuestion.id} />;
            default:
                return (
                    <Box sx={{ p: 2, textAlign: 'center', color: 'text.secondary' }}>
                        <Typography variant="body2">
                            Properties for {selectedQuestion.type} block type not implemented yet.
                        </Typography>
                    </Box>
                );
        }
    };

    return (
        <Box sx={{ display: 'flex', flexDirection: 'column', mt: 0 }}>
            <Paper sx={{ p: 1, mb: 2, minHeight: '90vh', overflow: 'visible' }}>
                <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
                    <Tabs value={tabValue} onChange={handleTabChange} aria-label="properties tabs">
                        <Tab label="Survey settings" id="simple-tab-0" aria-controls="simple-tabpanel-0" />
                        <Tab
                            label="Selected Question"
                            id="simple-tab-1"
                            aria-controls="simple-tabpanel-1"
                        />
                    </Tabs>
                </Box>

                <TabPanel value={tabValue} index={0}>
                    <SurveySettings />
                </TabPanel>

                <TabPanel value={tabValue} index={1}>
                    {renderProperties()}
                </TabPanel>
            </Paper>
        </Box>
    );
}

export default EcxSurveyProperties;
